import React from "react";

const STATUS_CONFIG = {
active: {
label: "Active",
className: "bg-green-50 text-green-700 ring-green-600/20",
dotClassName: "bg-green-500",
},

inactive: {
label: "Inactive",
className: "bg-gray-50 text-gray-600 ring-gray-500/20",
dotClassName: "bg-gray-400",
},

enabled: {
label: "Enabled",
className: "bg-green-50 text-green-700 ring-green-600/20",
dotClassName: "bg-green-500",
},

disabled: {
label: "Disabled",
className: "bg-gray-50 text-gray-600 ring-gray-500/20",
dotClassName: "bg-gray-400",
},
};

const QuestionStatusBadge = ({
isActive,
status,
label,
size = "sm",
showDot = true,
className = "",
}) => {
const normalizedStatus =
status ||
(isActive === false ? "inactive" : "active");

const config =
STATUS_CONFIG[normalizedStatus] ||
STATUS_CONFIG.inactive;

const displayLabel =
label ||
config.label ||
formatStatus(normalizedStatus);

const sizeClasses = {
xs: "px-1.5 py-0.5 text-[10px]",
sm: "px-2 py-0.5 text-xs",
md: "px-2.5 py-1 text-sm",
};

const dotSizes = {
xs: "h-1.5 w-1.5",
sm: "h-1.5 w-1.5",
md: "h-2 w-2",
};

return (
<span
className={[
"inline-flex items-center gap-1.5 rounded-full",
"font-medium ring-1 ring-inset",
sizeClasses[size] || sizeClasses.sm,
config.className,
className,
].join(" ")}
>
{showDot && (
<span
className={[
"shrink-0 rounded-full",
dotSizes[size] || dotSizes.sm,
config.dotClassName,
].join(" ")}
aria-hidden="true"
/>
)}


  {displayLabel}
</span>


);
};

const formatStatus = (value) => {
if (!value) return "Unknown";

return String(value)
.replace(/([A-Z])/g, " $1")
.replace(/[-_]/g, " ")
.replace(/\s+/g, " ")
.trim()
.replace(/^./, (char) => char.toUpperCase());
};

export default QuestionStatusBadge;
